import type { Site } from "@wix/ambassador-site-list-v2-site/build/cjs/types.impl";
import {
  Box,
  MessageModalLayout,
  Modal,
  Text,
  Thumbnail,
} from "@wix/design-system";
import { useTranslation } from "@wix/fe-essentials-standalone";
import { type FC } from "react";
import { useSiteThumbnail } from "./useSiteThumbnail";
import "./SiteThumbnail.css";
import { RotatedArrow } from "../Common/RotatedArrow";
import { useMobile } from "../../../hooks/useMobile";

interface SiteThumbnailProps {
  site: Site;
}

export const SiteThumbnail: FC<SiteThumbnailProps> = ({ site }) => {
  const { t } = useTranslation();
  const { handleClick, timePastSince, thumbnailUrl, error, setError } =
    useSiteThumbnail(site);
  const isMobile = useMobile();

  return (
    <>
      <Box direction="vertical" gap={2} margin={isMobile ? "24px 0" : "16px"}>
        <Thumbnail
          className="picasso-site-thumbnail"
          image={thumbnailUrl}
          title={
            <Box align="space-between" verticalAlign="middle">
              <Text>{site.displayName}</Text>
              <Box padding="4px">
                <RotatedArrow />
              </Box>
            </Box>
          }
          description={
            <Box align="left">
              {timePastSince &&
                (timePastSince.value > 0 ? (
                  <Text size="medium" secondary>
                    {t("landing.sites.time_past_since", {
                      formattedUnit: timePastSince.formattedUnit,
                    })}
                  </Text>
                ) : (
                  <Text size="medium" secondary>
                    {t("landing.sites.time_past_just_now")}
                  </Text>
                ))}
            </Box>
          }
          onClick={() => site?.id && handleClick(site.id)}
          width={
            isMobile
              ? "calc(100dvw - 32px)"
              : Math.min(312, window.innerWidth - 40)
          }
          height={isMobile ? "auto" : 191}
          textPosition="outside"
        />
      </Box>
      <Modal isOpen={!!error}>
        <MessageModalLayout
          theme="destructive"
          title={t("landing.sites.error")}
          content={<Text>{error}</Text>}
          onCloseButtonClick={() => setError(null)}
          primaryButtonText={t("landing.sites.close")}
          primaryButtonOnClick={() => setError(null)}
        />
      </Modal>
    </>
  );
};
